import { timeMixin } from './time';

export const mixins = {
	mixins: [ timeMixin ]
};